import React from 'react';

import '../stylesheet/geosuggest.css'
import '../stylesheet/navbar.css'
import '../stylesheet/application.css'
import '../stylesheet/regtabs.css'
import '../stylesheet/material.css'
import '../stylesheet/radiobuttonstyle.css'

import Landing from './register/landing.jsx';


class Application extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            width: props.innerWidth,
            height: props.innerHeight
        }
        this.updateWindowDimentions = this.updateWindowDimentions.bind(this);
    }
    componentDidMount() {
        this.updateWindowDimentions();
        window.addEventListener('resize', this.updateWindowDimentions);
        localStorage.setItem("loginState", false)
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimentions);
    }
    updateWindowDimentions(){
        this.setState({
                width: window.innerWidth + 'px',
                height : (window.innerHeight - 160) + 'px'
        })
        console.log("Size :" , `${this.state.width} x ${this.state.height} `)
    }
    render() {

        return (
            <div className="" >
                {/* <GusetNavbar /> */}
                <div className="" style={{minHeight:'580px' , backgroundColor: 'transparent'}}>
                    {/* <Login /> */}
                    <Landing/>
                </div>
            </div>
        );
    }
}



export default Application;



// WEBPACK FOOTER //
// ./src/components/application.jsx